/* eslint-disable camelcase */
import { type StrictAuthMethods } from 'src/auth/modules/StrongCustomerAuthentication/models/factors';
import type { AuthI18nKey } from 'src/core/common/hooks/useTranslation';
import { TypeGuardError } from 'src/core/utils/switchGuard';

const authenticationMethodLabelTranslationKeys = {
  totp: 'sca.alternateAuthenticationMethodModal.methods.totp.title',
  sms: 'sca.alternateAuthenticationMethodModal.methods.sms.title',
  email: 'sca.alternateAuthenticationMethodModal.methods.email.title',
} as const satisfies Record<Lowercase<StrictAuthMethods>, AuthI18nKey>;

const authenticationMethodDescriptionTranslationKeys = {
  totp: 'sca.alternateAuthenticationMethodModal.methods.totp.description',
  sms: 'sca.alternateAuthenticationMethodModal.methods.sms.description',
  email: 'sca.alternateAuthenticationMethodModal.methods.email.description',
} as const satisfies Record<Lowercase<StrictAuthMethods>, AuthI18nKey>;

export function getAuthenticationMethodTranslations(
  method: StrictAuthMethods,
): { label: AuthI18nKey; description: AuthI18nKey } {
  const lowercaseMethod = method.toLowerCase() as Lowercase<StrictAuthMethods>;

  switch (lowercaseMethod) {
    case 'totp':
    case 'sms':
    case 'email':
      return {
        label: authenticationMethodLabelTranslationKeys[lowercaseMethod],
        description:
          authenticationMethodDescriptionTranslationKeys[lowercaseMethod],
      };
    default:
      throw new TypeGuardError(
        lowercaseMethod,
        `Unknown authentication method ${lowercaseMethod}`,
      );
  }
}

const authenticationOperationTitleTranslationKeys = {
  totp: 'sca.verifyAuthenticationOperationModal.methods.totp.title',
  sms: 'sca.verifyAuthenticationOperationModal.methods.sms.title',
  email: 'sca.verifyAuthenticationOperationModal.methods.email.title',
} as const satisfies Record<Lowercase<StrictAuthMethods>, AuthI18nKey>;

const authenticationOperationDescriptionTranslationKeys = {
  totp: 'sca.verifyAuthenticationOperationModal.methods.totp.description',
  sms: 'sca.verifyAuthenticationOperationModal.methods.sms.description',
  email: 'sca.verifyAuthenticationOperationModal.methods.email.description',
} as const satisfies Record<Lowercase<StrictAuthMethods>, AuthI18nKey>;

export function getAuthenticationOperationTranslations(
  method: StrictAuthMethods,
): { title: AuthI18nKey; description: AuthI18nKey } {
  const lowercaseMethod = method.toLowerCase() as Lowercase<StrictAuthMethods>;

  switch (lowercaseMethod) {
    case 'totp':
    case 'sms':
    case 'email':
      return {
        title: authenticationOperationTitleTranslationKeys[lowercaseMethod],
        description:
          authenticationOperationDescriptionTranslationKeys[lowercaseMethod],
      };
    default:
      throw new TypeGuardError(
        lowercaseMethod,
        `Unknown authentication method ${lowercaseMethod}`,
      );
  }
}
